import { css } from 'styled-components';
import { media } from '../../../helpers/mixins';
import { PURPLE, PINK, WHITE } from '../../../constants/colors';

export default {

  header: () => css`
    box-sizing: border-box;
    align-items: center;
    -webkit-box-align: center;
    -webkit-box-direction: normal;
    line-height: 1;
    padding: 5px 20px 10px 20px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
  `,
  title: css`
    flex: 1 1 0%;
    line-height: 24px;
    margin-bottom: 0px;
    font-weight: 500;
    color:${PURPLE};
    text-align:center;
  `,
  body: css`
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 6px;
    padding-bottom: 16px;
  `,
  footer: css`
    display: flex;
    clear: both;
    content: '';
    padding: 10px 20px 25px 20px;
    justify-content: center;
  `,
  primary: css`
    font-weight: bold;
  `,
  button: css`
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    cursor: pointer;
    font-weight: 400;
    color: #007bff;
    text-decoration: none;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    color:${WHITE};
    background-color: ${PINK};
    margin-left:10px;
    border: 1px solid transparent;
    padding: 0.3rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    overflow: visible;
  `,

  container: css`
    margin-bottom: 20px;
    border-radius: 10px;
    border-style: solid;
    border-color: gray;
    padding: 20px 10px;
  `,

  column: css`
    ${media.md`
      flex-direction: column;
      justify-content: center;
      align-self: center;
      display: flex;
    `};
  `,
  
  row: css`
    flex-direction: row;
    display: flex;
  `,

  typeColor: ({color}) => css`
    background-color: ${color};
    height: 8px;
    width: 8px;
    justify-content: center;
    align-self: center;
    margin: 0 5px;
  `,

  buttonContainer: css`
    margin: 10px 0px 0px;
    width: 100%;
    display: flex;
    justify-content: end;
  `,
};
